import{Z as s,d as o}from"./p-Chps26eE.js";const p=s;const t=o;export{p as ZprModal,t as defineCustomElement};
//# sourceMappingURL=zpr-modal.js.map